import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./Configuration.css";

const Configuration = () => {
  const { siteId } = useParams();
  const [formData, setFormData] = useState({
    diesel_ust1_stock: "",
    petrol_ust2_stock: "",
    petrol_ust3_stock: "",
    diesel_ust4_stock: "",

    dieseldensity_ust1: "",
    petroldensity_ust2: "",
    petroldensity_ust3: "",
    dieseldensity_ust4: "",
    
    
    diesel_ust1_rate: "",
    petrol_ust2_rate: "",
    petrol_ust3_rate: "",
    diesel_ust4_rate: "",
  });

  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState(""); // To display success message

  // Fetch initial data from the API
  useEffect(() => {
    const fetchFuelData = async () => {
      if (!siteId) {
        setLoading(false);
        return;
      }

      try {
        const siteIdInt = parseInt(siteId, 10);
        if (isNaN(siteIdInt)) {
          setLoading(false);
          return;
        }

        const response = await axios.get("/fuel-data", {
          params: {
            site_id: siteIdInt
          }
        });
        setFormData(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching fuel data:", error);
        setLoading(false);
      }
    };

    fetchFuelData();
  }, [siteId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!siteId) return;
    
    const siteIdInt = parseInt(siteId, 10);
    if (isNaN(siteIdInt)) return;

    try {
      await axios.put("/update-fuel-data", formData, {
        params: {
          site_id: siteIdInt
        }
      });
      setSuccessMessage("Fuel data updated successfully!"); 
      setTimeout(() => setSuccessMessage(""), 5000); // Clear message after 5 seconds
    } catch (error) {
      console.error("Error updating fuel data:", error);
      alert("Failed to update fuel data.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <h2>Update Fuel Data</h2>
      <div className="scroll-container">
      <form className="fuel-form" onSubmit={handleSubmit}>
       
        {successMessage && <div className="success-message">{successMessage}</div>}
         <div className="form-group">
          <label>Diesel UST1 Stock (L):</label>
          <input
            type="number"
            name="diesel_ust1_stock"
            value={formData?.diesel_ust1_stock || ""}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Petrol UST2 Stock (L):</label>
          <input
            type="number"
            name="petrol_ust2_stock"
            value={formData?.petrol_ust2_stock || ""}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Petrol UST3 Stock (L):</label>
          <input
            type="number"
            name="petrol_ust3_stock"
            value={formData?.petrol_ust3_stock || ""}
            onChange={handleChange}
            required
          />
        </div>
             <div className="form-group">
          <label>Diesel UST4 Stock (L):</label>
          <input
            type="number"
            name="diesel_ust4_stock"
            value={formData?.diesel_ust4_stock || ""}
            onChange={handleChange}
            required
          />
        </div>
         <div className="form-group">
          <label>Diesel UST1 Density (Kg/m^3):</label>
          <input
            type="number"
            name="dieseldensity_ust1"
            value={formData?.dieseldensity_ust1 || ""}
            onChange={handleChange}
            required
          />
        </div>
         <div className="form-group">
          <label>Petrol UST2 Density (Kg/m^3):</label>
          <input
            type="number"
            name="petroldensity_ust2"
            value={formData?.petroldensity_ust2 || ""}
            onChange={handleChange}
            required
          />
        </div>
         <div className="form-group">
          <label>Petrol UST3 Density (Kg/m^3):</label>
          <input
            type="number"
            name="petroldensity_ust3"
            value={formData?.petroldensity_ust3 || ""}
            onChange={handleChange}
            required
          />
        </div>
           <div className="form-group">
          <label>Diesel UST4 Density (Kg/m^3):</label>
          <input
            type="number"
            name="dieseldensity_ust4"
            value={formData?.dieseldensity_ust4 || ""}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Diesel UST1 Rate (Rs):</label>
          <input
            type="number"
            name="diesel_ust1_rate"
            value={formData?.diesel_ust1_rate || ""}
            onChange={handleChange}
            required
          />
        </div>
         <div className="form-group">
          <label>Petrol UST2 Rate (Rs):</label>
          <input
            type="number"
            name="petrol_ust2_rate"
            value={formData?.petrol_ust2_rate || ""}
            onChange={handleChange}
            required
          />
        </div>
         <div className="form-group">
          <label>Petrol UST3 Rate (Rs):</label>
          <input
            type="number"
            name="petrol_ust3_rate"
            value={formData?.petrol_ust3_rate || ""}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Diesel UST4 Rate (Rs):</label>
          <input
            type="number"
            name="diesel_ust4_rate"
            value={formData?.diesel_ust4_rate || ""}
            onChange={handleChange}
            required
          />
        </div>
        {/* <div className="form-group">
          <label>Petrol Stock (KL):</label>
          <input
            type="number"
            name="petrolstock"
            value={formData}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Petrol Density UST 1(Kg/m³):</label>
          <input
            type="number"
            name="petroldensity"
            value={formData.petroldensity}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Petrol Density UST 2(Kg/m³):</label>
          <input
            type="number"
            name="petroldensity_ust2"
            value={formData.petroldensity_ust2}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Petrol Rate (₹/L):</label>
          <input
            type="number"
            name="petrolrate"
            value={formData.petrolrate}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Diesel Stock (KL):</label>
          <input
            type="number"
            name="dieselstock"
            value={formData.dieselstock}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Diesel Density UST 1(Kg/m³):</label>
          <input
            type="number"
            name="dieseldensity"
            value={formData.dieseldensity}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Diesel Density UST 2(Kg/m³):</label>
          <input
            type="number"
            name="dieseldensity_ust2"
            value={formData.dieseldensity_ust2}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Diesel Rate (₹/L):</label>
          <input
            type="number"
            name="dieselrate"
            value={formData.dieselrate}
            onChange={handleChange}
            required
          />
        </div> */}
        <button type="submit">Update Fuel Data</button>
      </form>
      </div>
      </>
  );
};
export default Configuration;
